const playBtns = document.querySelectorAll<HTMLElement>('.video-inline__play');
const autoplayVideos = document.querySelectorAll<HTMLElement>('.video-inline--autoplay');

function initAutoplayVideos() {
	autoplayVideos.forEach((video) => {
		const iframe = video.querySelector<HTMLIFrameElement>('iframe');
		if (!iframe || iframe.classList.contains('playing')) {
			return;
		}

		if (video.classList.contains('video-inline--no-mobile') && window.innerWidth < 992) {
			iframe.removeAttribute('src');
			return;
		}

		if (window.Vimeo?.Player) {
			const player = new window.Vimeo.Player(iframe);
			player.on('play', () => {
				iframe.classList.add('playing');
			});
			player.getPaused().then((paused) => {
				if (!paused) {
					iframe.classList.add('playing');
				}
			});
		}
	});
}

window.addEventListener('load', initAutoplayVideos);
window.addEventListener('rocket-allScriptsLoaded', initAutoplayVideos);

playBtns.forEach((playBtn) => {
	playBtn.addEventListener('click', () => {
		const media = playBtn.parentElement;
		if (!media) return;

		media.classList.add('component-media--show-video');

		const video = media.querySelector<HTMLElement>('.video-inline');
		if (!video) return;

		video.classList.add('video-inline--is-visible');
		playBtn.style.display = 'none';

		const iframe = video.querySelector<HTMLIFrameElement>('iframe');
		if (iframe) {
			const videoSrc = iframe.getAttribute('data-src');
			if (videoSrc) {
				iframe.src = videoSrc;
				iframe.classList.add('visible');
			}
		}
	});
});
